export default __webpack_public_path__ + "static/media/Padel Store.9c282123.jpg";